import type { DevToolsSectionHeaderProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsSectionHeader/index.types';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * DevToolsSectionHeader - A tab's own title, with what it is counting
 */
export const DevToolsSectionHeader: React.FC<DevToolsSectionHeaderProps> = ({
  title,
  count,
  className,
}) => (
  <div className={cn('flex items-center gap-2', className)}>
    <h3 className="text-[14px] font-semibold text-zinc-200">{title}</h3>
    {count !== undefined && (
      <span className="rounded-[5px] bg-zinc-800 px-1.5 py-px font-sp-mono text-[11px] text-zinc-300">
        {count}
      </span>
    )}
  </div>
);
